import React, { FunctionComponent } from "react";
import { useDispatch } from "react-redux";
import { ListSubheader, MenuItem } from "@mui/material";
import { useFlags } from "../../services/utilities/launch_darkly_helper";

import downloadFiltered5dTsv from "../../actions/budget_page/download_filtered_5d_tsv";
import getExportStarted from "../../services/getters/get_export_started";
import getMasterformatSelections from "../../services/getters/wbs_getters/get_masterformat_selections";
import NavBarKebabMenu from "./nav_bar_kebab_menu";
import NavBarManageUsersIcon from "./nav_bar_manage_users_icon";
import useAvvirSelector from "../../services/component_helpers/component_effects/use_avvir_selector";

import type { Dispatch } from "type_aliases";

type DispatchedEvents = ReturnType<typeof downloadFiltered5dTsv>;
export const NavBarControlsWbs: FunctionComponent = () => {
  const { updated5DExport, customerFacingManageUsers } = useFlags();
  const dispatch = useDispatch() as Dispatch<DispatchedEvents>;
  const exportStarted = useAvvirSelector(getExportStarted);
  const filter = useAvvirSelector(getMasterformatSelections);
  const exports: React.JSX.Element[] = [];
  if (!updated5DExport) {
    exports.push(<ListSubheader
      key="NavBarKebabMenu-ExportsMenuHeading"
      disableSticky
      disableGutters
      className="NavBarKebabMenu-label"
      role="heading"
    >
      Exports
    </ListSubheader>);
    exports.push(<MenuItem
      key="NavBarKebabMenu-5dTsvExportMenuItem"
      className="NavBarKebabMenu-5dTsv NavBarKebabMenu-menuItem"
      disabled={exportStarted}
      onClick={() => dispatch(downloadFiltered5dTsv(filter))}
    >
      Visible Line Items (.tsv)
    </MenuItem>);
  }

  return <>
    {customerFacingManageUsers && <NavBarManageUsersIcon/>}
    <NavBarKebabMenu>
      {exports}
    </NavBarKebabMenu>
  </>;
};

export default NavBarControlsWbs;
